/**
 * Asynchronously loads the component for UserManagement
 */

import { lazyLoad } from 'utils/loadable';
import LoadingSpinner from 'app/components/Loading/LoadingSpinner';

export const UserManagement = lazyLoad(
    () => import('./index'),
    module => module.UserManagement,
    { fallback: <LoadingSpinner /> },
);
